import { render, staticRenderFns } from "./ProductsAtGlanceItem.vue?vue&type=template&id=cf654368&scoped=true&"
import script from "./ProductsAtGlanceItem.vue?vue&type=script&lang=js&"
export * from "./ProductsAtGlanceItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAtGlanceItem.vue?vue&type=style&index=0&id=cf654368&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf654368",
  null
  
)

export default component.exports